export default (value) => {
  return value === 'true' ? true : value === 'false' ? false : value
}
